export default __webpack_public_path__ + "static/media/CSS3.fec65885.svg";